import dayjs from "dayjs";

export function timeToMinutes(time) {
  // returns number of minutes since 5 am. Used in EventGrid for evaluating event duration and in CurrentTimeIndicator for positioning
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes - 300; // Subtract 300 minutes (5 hours)
}

export function calculateMinutesDuration(startTime, endTime) {
  // Takes start and end times (HH:MM) and returns the duration in minutes. Used in EventGrid for evaluating event duration
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);
  let durationMinutes = endMinutes - startMinutes;
  if (durationMinutes < 0) {
    durationMinutes += 24 * 60;
  }
  return durationMinutes;
}

export function pullObjectInfo(table, objectId) {
  // Gets and returns a single object from a collection by ID. Used in numerous places where a specific object value is needed
  for (let entry of table) {
    if (entry.id === objectId) {
      return entry;
    }
  }
}

export function generateChangelog(
  eventA,
  eventB,
  { eventTypes, aircraft, instructors, dpes, customers },
) {
  let changelog = "<div>";

  const fields = [
    {
      key: "eventTypeId",
      label: "Event type",
      lookup: (id) => pullObjectInfo(eventTypes, id)?.name,
    },
    { key: "title", label: "Title" },
    {
      key: "startDateTime",
      label: "Start",
      format: (date) => dayjs(date).format("ddd, MMM DD hh:mm A"),
    },
    {
      key: "endDateTime",
      label: "End",
      format: (date) => dayjs(date).format("ddd, MMM DD hh:mm A"),
    },
    {
      key: "aircraftId",
      label: "Aircraft",
      lookup: (id) => pullObjectInfo(aircraft, id)?.name,
    },
    {
      key: "instructorId",
      label: "Instructor",
      lookup: (id) => pullObjectInfo(instructors, id)?.name,
    },
    {
      key: "dpeId",
      label: "DPE",
      lookup: (id) => pullObjectInfo(dpes, id)?.name,
    },
    {
      key: "customer1Id",
      label: "Customer 1",
      lookup: (id) => pullObjectInfo(customers, id)?.name,
    },
    {
      key: "customer2Id",
      label: "Customer 2",
      lookup: (id) => pullObjectInfo(customers, id)?.name,
    },
    { key: "dayNightFlight", label: "Day/Night" },
    { key: "flightType", label: "Type" },
    { key: "flightRules", label: "Rules" },
    { key: "flightRoute", label: "Route" },
    { key: "flightTime", label: "Est. Hours" },
    { key: "comments", label: "Comments" },
    { key: "internalComments", label: "Internal Comments" },
    { key: "status", label: "Status" },
  ];

  fields.forEach(({ key, label, lookup, format }) => {
    // Check if the field exists in eventB; if not, skip
    if (key in eventB) {
      const newValue = format
        ? format(eventB[key])
        : lookup
          ? lookup(eventB[key])
          : eventB[key];
      const oldValue =
        eventA && key in eventA
          ? format
            ? format(eventA[key])
            : lookup
              ? lookup(eventA[key])
              : eventA[key]
          : null;

      if (!eventA || oldValue !== newValue) {
        changelog += `<div style="float: left;">${label}: <strong style="color: #3171e2;">${newValue}</strong></div><br/>`;
      }
    }
  });

  changelog += "</div>";
  return changelog;
}
